module.exports = __webpack_public_path__ + "img/e_3_1_r.e20a5322.png";